
import {Modal} from "bootstrap-v5";

export function initCalculator(scope)
{
	let scopeElement = scope[0];
	if(scopeElement){
		let buttonElements = scopeElement.querySelectorAll(".addProductToCalculator");
		for(let buttonElement of buttonElements){
			buttonElement.addEventListener("click", function(e){
				e.preventDefault();

				//close modal before ajax (after ajax, modal no longer exists)
				Modal.getInstance(buttonElement.closest(".modal")).hide();

				//send signal
				$.nette.ajax({
					method: "POST",
					url: buttonElement.dataset.target
				});
			});
		}
	}
}
